import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { NAV_ITEMS } from '../data/navigation';
import styles from './DesktopNav.module.css';

interface DesktopNavProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const DesktopNav: React.FC<DesktopNavProps> = ({
  activeSection,
  onSectionChange,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const handleSectionClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    sectionId: string
  ): void => {
    e.preventDefault();
    if (isHomePage) {
      onSectionChange(sectionId);
      document
        .getElementById(sectionId)
        ?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  return (
    <nav className={styles.desktopNav} aria-label="メインナビゲーション">
      <ul className={styles.navList}>
        {NAV_ITEMS.map((item) => (
          <li key={item.id} className={styles.navItem}>
            {item.kind === 'route' ? (
              <Link
                to={item.to}
                className={`${styles.navLink} ${item.emphasis ? styles.emphasis : ''}`}
              >
                {item.label}
              </Link>
            ) : (
              <Link
                to={isHomePage ? `#${item.sectionId}` : `/#${item.sectionId}`}
                className={styles.navLink}
                onClick={(e) => handleSectionClick(e, item.sectionId)}
                aria-current={
                  activeSection === item.sectionId ? 'page' : undefined
                }
              >
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default DesktopNav;
